var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.76162 12.7367L5.05454 15.5707C4.21558 16.2121 3.00837 15.6129 3.00663 14.5584L3.00345 12.6284C1.2774 12.2133 0 10.6548 0 8.80337V3.93338C0 1.76174 1.75503 0 3.92157 0H12.7451C14.9116 0 16.6667 1.76174 16.6667 3.93338V8.80337C16.6667 10.975 14.9116 12.7367 12.7451 12.7367H8.76162ZM4.67199 13.7653L7.97346 11.2414C8.11879 11.1303 8.29664 11.0701 8.47957 11.0701H12.7451C13.9897 11.0701 15 10.056 15 8.80337V3.93338C15 2.6808 13.9897 1.66667 12.7451 1.66667H3.92157C2.67693 1.66667 1.66667 2.6808 1.66667 3.93338V8.80337C1.66667 10.0324 2.64088 11.0358 3.85844 11.0692C4.30908 11.0816 4.66817 11.4501 4.66892 11.9009L4.67199 13.7653Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/Message.bb53ee73514531e8db79bc82d100b9b5.svg";
export { ForwardRef as ReactComponent };